import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { postData } from "../Api";

const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    star: "5",
    description: "",
  });

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await postData("/review", formData);

      setSuccessMessage("✅ Feedback Submitted Successfully!");
      setShowModal(true);
      setFormData({ name: "", star: "5", description: "" });

      setTimeout(() => {
        setShowModal(false);
        navigate("/");
      }, 2000);
    } catch (error) {
      console.error("Feedback Submission Failed:", error);
      alert("🚨 Feedback Submission Failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <h4 className="fw-bold text-center mb-4">Feedback Form</h4>

          <form onSubmit={handleSubmit}>
            <h5 className="fw-bold">Contact Information</h5>
            <div className="row">
              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  className="form-control py-3"
                  placeholder="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <div className="form-floating">
                  <select
                    className="form-select"
                    name="star"
                    value={formData.star}
                    onChange={handleChange}
                    required
                  >
                    <option value="1">1 Star (Taste is very bad)</option>
                    <option value="2">2 Star (Taste is bad)</option>
                    <option value="3">3 Star (Taste is average)</option>
                    <option value="4">4 Star (Taste is good)</option>
                    <option value="5">5 Star (Taste is very delicious)</option>
                  </select>
                  <label>Rate our overall services</label>
                </div>
              </div>
            </div>

            <h5 className="fw-bold">Feedback Information</h5>
            <div className="mb-3">
              <textarea
                className="form-control"
                rows="4"
                placeholder="Write your feedback."
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="btn-style1" disabled={loading}>
              {loading ? "Submitting..." : "Submit Your Feedback"}
            </button>
          </form>
        </div>
      </div>

      {/* ✅ Success Modal */}
      {showModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content py-md-5 py-3 rounded-5">
              <div className="modal-body text-center">
                <FaCheckCircle size={60} color="green" />
                <h2 className="py-md-3 py-2">{successMessage}</h2>
                <button
                  type="button"
                  className="btn btn-success mt-3"
                  onClick={() => navigate("/")}
                >
                  Go to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default FeedbackForm;
